import $ from 'jquery';
import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Chessboard from '../Chessboard';
import { initialFen, ENGINES_NAMES } from '../../../utils';
import { parse } from '../../../chessUtils';

const fen = window.name ? window.name.split('_')[0] : initialFen;
const pgn = window.name ? window.name.split('_')[1] : '';

const useStyles = makeStyles({
  root: {
    marginTop: '15%'
  }
});

export default class Pro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      websockets: {},
      variations: {},
      isAnalysis: {},
      callbacks: {}
    };
  }

  componentDidMount() {
    window.startEngineAnalyze = this.startEngineAnalyze;
    window.stopEngineAnalyze = this.stopEngineAnalyze;
    window.isEngineAnalysis = this.isEngineAnalysis;
    window.updateEngineAnalysis = this.updateEngineAnalysis;
    window.stopServerOrder = this.stopServerOrder;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { orderedEnginesInfo } = nextProps;
    const orderedEngines = Object.keys(orderedEnginesInfo);
    const { websockets, variations, isAnalysis } = this.state;
    const websocketsKeys = Object.keys(websockets);
    for (let i = 0; i < websocketsKeys.length; i++) {
      if (!orderedEnginesInfo[websocketsKeys[i]]) {
        delete websockets[websocketsKeys[i]];
        delete variations[websocketsKeys[i]];
        delete isAnalysis[websocketsKeys[i]];
      }
      this.setState({ websockets, variations, isAnalysis });
    }

    for (let i = 0; i < orderedEngines.length; i++) {
      const engine = orderedEngines[i];
      const engineWebSocket = websockets[engine];
      if (
        !engineWebSocket ||
        (this.props.orderedEnginesInfo[engine] &&
          nextProps.orderedEnginesInfo[engine] &&
          this.props.orderedEnginesInfo[engine][0].for_guests !==
            nextProps.orderedEnginesInfo[engine][0].for_guests)
      ) {
        //window.setEngineAnalyze(engine);
        //this.createWebSocket(engine, orderedEnginesInfo[engine][1]);
      }
    }
  }

  createWebSocket = (engine, channel) => {
    const { websockets, variations, isAnalysis } = this.state;
    const socket = new WebSocket(channel);
    socket.onopen = event => {
      const fen = window.getFen();
      const PV = window.getPV(engine) || 3;
      socket.send(`setoption name MultiPV value ${PV}`);
      socket.send(`position fen ${fen}`);
      socket.send('go infinite');
    };

    socket.onmessage = event => {
      const data = event.data;
      this.collectVariations(data, engine);
    };

    socket.onclose = event => {
      const { websockets } = this.state;
      delete websockets[engine];
      this.setState({ websockets });
      console.log('WebSocket is closed now.', engine);
    };

    websockets[engine] = socket;
    variations[engine] = [];
    isAnalysis[engine] = true;
    this.setState({ websockets, variations, isAnalysis });
  };

  collectVariations(data, engine) {
    const { isAnalysis, callbacks, variations } = this.state;
    const { orderedEnginesInfo } = this.props;

    if (data.includes('bestmove')) {
      variations[engine] = [];
      isAnalysis[engine] = false;
      this.setState({ variations, isAnalysis });
      if (callbacks[engine]) {
        callbacks[engine]();
      }
      return;
    }

    if (!data || !data.includes('pv') || !orderedEnginesInfo[engine]) {
      return;
    }

    const PV = window.getPV(engine) || 3;
    variations[engine].push(data);
    if (variations[engine].length == PV) {
      const engineVariation = variations[engine];
      const engineInfo = orderedEnginesInfo[engine];
      const engine_name =
        !engineInfo[0].for_guests || engine === 'sugar' || engine === 'asmfish'
          ? ENGINES_NAMES[engine]
          : ENGINES_NAMES['stockfish10'];
      const analyze = parse(
        engineVariation,
        window.getFen(),
        engine,
        engine_name
      );
      setTimeout(() => {
        if (isAnalysis[engine] && orderedEnginesInfo[engine]) {
          window.setAnalysis(analyze);
        }
      }, 100);
      variations[engine] = [];
    }
    this.setState({ variations });
  }

  startEngineAnalyze = (engine, cb) => {
    if (!engine) {
      return;
    }

    const { websockets, isAnalysis, variations } = this.state;
    const websocket = websockets[engine];
    if (!websocket || websocket.readyState === WebSocket.CLOSED) {
      console.log('Websocket is closed');
      return;
    }
    this.stopEngineAnalyze(engine, () => {
      const PV = window.getPV(engine) || 3;
      const fen = window.getFen();
      websocket.send(`setoption name MultiPV value ${PV}`);
      websocket.send(`position fen ${fen}`);
      websocket.send('go infinite');
      isAnalysis[engine] = true;
      this.setState({ isAnalysis });
      cb();
    });
  };

  updateEngineAnalysis = cb => {
    const { websockets, variations, isAnalysis, callbacks } = this.state;
    const { orderedEnginesInfo } = this.props;
    const orderedEngines = Object.keys(orderedEnginesInfo);
    for (let i = 0; i < orderedEngines.length; i++) {
      const engine = orderedEngines[i];
      this.startEngineAnalyze(engine, cb);
    }
  };

  isEngineAnalysis = engine => {
    const { isAnalysis } = this.state;
    return isAnalysis[engine];
  };

  stopServerOrder = (engine, cb) => {
    const { isAnalysis, websockets } = this.state;
    const websocket = websockets[engine];
    websocket.send('stop');
    isAnalysis[engine] = false;
    this.setState({ isAnalysis });
    cb();
  };

  stopEngineAnalyze = (engine, cb) => {
    const { websockets, callbacks, isAnalysis } = this.state;
    const websocket = websockets[engine];
    if (
      !websocket ||
      websocket.readyState === WebSocket.CLOSED ||
      !isAnalysis[engine]
    ) {
      cb();
      return;
    }
    websocket.send('stop');
    callbacks[engine] = cb;
    this.setState({ callbacks });
  };

  render() {
    const { isAnalysis } = this.state;
    const { orderedEnginesInfo } = this.props;
    const orderedEngines = Object.keys(orderedEnginesInfo);
    let isAnalysing = false;
    for (let i = 0; i < orderedEngines.length; i++) {
      if (isAnalysis[orderedEngines[i]]) {
        isAnalysing = true;
        break;
      }
    }
    return (
      <Chessboard
        mode="analyze"
        fen={window && window.getFen ? window.getFen() : fen}
        pgn={
          window && window.getPgnWithVariations
            ? window.getPgnWithVariations()
            : pgn
        }
        balance={this.props.balance}
        isAnalysing={isAnalysing}
        goToPricingPage={this.props.goToPricingPage}
      />
    );
  }
}
